import globalMessaging from "ducks/global_messaging";
import { reducer as quickmatch } from "ducks/quickmatch";
import { reducer as discovery } from "ducks/discovery";
import { reducer as questions } from "ducks/questions";
import { reducer as profileQuestions } from "ducks/profile_questions";
import { reducer as profile } from "ducks/profile";
import { reducer as instagram } from "ducks/profile_instagram";
import { reducer as photoOverlay } from "ducks/photo_overlay";
import { reducer as profileEdit } from "ducks/profile_edit";
import { reducer as editWIW } from "ducks/edit_wiw";
import { reducer as editDetails } from "ducks/edit_details";
import { reducer as whatIWant } from "ducks/what_i_want";
import { reducer as photoUpload } from "ducks/photo_upload";
import { reducer as passionsPicker } from "ducks/passions_picker";
import { reducer as globalPreferences } from "ducks/global_preferences";
import { reducer as sms } from "ducks/sms";
import { reducer as staffbar } from "ducks/staffbar";
import alistPackages from "ducks/alist_packages";
import { reducer as onboarding } from "ducks/onboarding";
import { reducer as photoOrganizer } from "ducks/photo_organizer";
import { reducer as profileDetails } from "ducks/profile_details";
import { reducer as incognitoPackages } from "ducks/incognito_packages";
import { reducer as login } from "ducks/login";
import { reducer as smsLogin } from "ducks/sms_login";
import { reducer as signup } from "ducks/signup";
import { reducer as nonbinary } from "ducks/nonbinary";
import { reducer as realnames } from "ducks/realnames";
import { reducer as careers } from "ducks/careers";

export default {
	globalMessaging,
	quickmatch,
	discovery,
	questions,
	profile,
	profileQuestions,
	instagram,
	photoOverlay,
	profileEdit,
	editWIW,
	editDetails,
	whatIWant,
	photoUpload,
	passionsPicker,
	globalPreferences,
	sms,
	staffbar,
	alistPackages,
	onboarding,
	photoOrganizer,
	profileDetails,
	incognitoPackages,
	login,
	smsLogin,
	signup,
	nonbinary,
	realnames,
	careers,
};



// WEBPACK FOOTER //
// ./src/routers/Desktop/Store/reducers.js